import Vue from "vue";
import axios from "axios";
import store from "./../index";

export default {
  namespaced: true,

  actions: {
    sendAppeal(_, payload) {
      store.commit("setLoader", true);
      return axios
        .post(`/home/carier`, payload)
        .then((response) => {
          console.log(payload);
          if (response && response.status === 201) {
            Vue.$toast.success(response.data.message);
            return true;
          }
        })
        .catch(() => {
          return false;
        });
    },
  },
};
